export const userRoleEnum = {
  ADMIN: 'admin',
  USER: 'user'
}
